var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "aside",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.$root.$data.lightboxToggled === _vm.name,
          expression: "$root.$data.lightboxToggled === name"
        }
      ],
      staticClass: "ui-lightbox",
      class: { video__pause: _vm.name.indexOf("lightboxVideo") > -1 },
      attrs: { for: _vm.name },
      on: {
        mousedown: function($event) {
          return _vm.$root.lightboxClick($event)
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }